// NOTE:  the filters work on the frontend directly on the metaData field make to add the metaData property name to each filter.

// Tenant-specific configurations
const imageTagsFields = [
  "main.imagesFromTheGroupDiscussion",
  "main.images",
  "main.accessToInformationImage",
  "main.makingChoicesImages",
  "main.healthcareAccessImages",
  "main.learningCurveImages",
  "main.expandedOptionsImages",
  "main.informalNetworksImages",
  "main.transactionCostImages",
  "main.partnerSupportImages",
  "main.seekingPrivacyImages",
  "main.desiredFeatureImages",
];

const tenantConfigs = {
  gelabs: {
    contentTypes: [
      "kenyaMediaTemplate",
      "communityImmersionTemplate",
      "senegalImmersion2Fgd",
    ],

    fieldConfig: {
      // Image fields to extract
      imageFields: [
        ...imageTagsFields,
        "main.coverImage",
      ],
      // Single image fields extract
      singleImageFields: [], // this is not required i think also will not work correctly since the data structure is still array for a single image input.
      // Repeater image fields extract
      repeaterImageFields: [],
      // Metadata fields extract
      metadataFields: {
        contentType: "meta.kp_content_type",
        findings: "findings",
        insights: "insights",
        segmentationNigeria: "tags.segmentationNigeria",
        segmentationSenegal: "tags.segmentationSenegal",
        segmentKenya: "tags.segmentKenya",
        publishDate: "kp_date_published",
      },
    },

    filterConfig: [
      {
        filterId: "contentType",
        display: "Content Type",
        source: {
          filterType: "staticType",
          options: []
        },
        target: {},
      },

      {
        filterId: "segmentationNigeria",
        display: "Segmentation Nigeria",
        metadataField: "segmentationNigeria",
        source: {
          filterType: "tagType",
          tagType: "segmentationNigeria",
        },
        target: { filterType: "tagType", tagType: "segmentationNigeria" },
      },

      {
        filterId: "segmentationSenegal",
        display: "Segmentation Senegal",
        metadataField: "segmentationSenegal",
        source: {
          filterType: "tagType",
          tagType: "segmentationSenegal",
        },
        target: {
          filterType: "tagType",
          tagType: "segmentationSenegal",
        },
      },
      {
        filterId: "segmentKenya",
        display: "Segmentation Kenya",
        metadataField: "segmentKenya",
        source: {
          filterType: "tagType",
          tagType: "segmentKenya",
        },
        target: {
          filterType: "valuePathType",
          valuePath: "tags.segmentKenya.data._id",
        },
      },
      {
        filterId: "findings",
        display: "Findings",
        metadataField: "findings",
        source: {
          filterType: "tagType",
          tagType: "findings",
        },
        target: {
          filterType: "TEMP_HACK_mediaLibrary_imageTagType",
          valuePaths: imageTagsFields.map(field => `${field}.tags.findings.data._id`),
        },
      },
      {
        filterId: "insights",
        display: "Insights",
        metadataField: "insights",
        source: {
          filterType: "tagType",
          tagType: "insights",
        },
        target: {
          filterType: "TEMP_HACK_mediaLibrary_imageTagType",
          valuePaths: imageTagsFields.map(field => `${field}.tags.insights.data._id`),
        },
      },
    ],

    get projections() {
      const projections = {};

      // Add image fields to projections
      [
        ...this.fieldConfig.imageFields,
        ...this.fieldConfig.singleImageFields,
        ...this.fieldConfig.repeaterImageFields,
      ].forEach((field) => {
        projections[field] = 1;
      });

      // Add metadata fields to projections
      Object.values(this.fieldConfig.metadataFields).forEach((field) => {
        projections[field] = 1;
      });

      return projections;
    },
    findQuery: { kp_published_status: "published" },
  },
};

export const getTenantConfig = (tenantId) => {
  return tenantConfigs[tenantId];
};

export const genfilterConfig = ({ contentTypes, allTpls, tenantConfig }) => {
  if (!tenantConfig || !tenantConfig.filterConfig) {
    return [];
  }

  // Use tenant-specific filter configuration
  return tenantConfig.filterConfig.map((filter) => {
    // Create a copy of the filter to avoid modifying the original
    const filterCopy = { ...filter, target: {} };

    // For contentType filter, dynamically generate options
    if (
      filter.filterId === "contentType" &&
      filter.source.filterType === "staticType"
    ) {
      filterCopy.source = {
        ...filterCopy.source,
        options: allTpls
          .filter((d) => contentTypes.includes(d.kp_content_type))
          .map((d) => ({
            display: d.general.content.title,
            value: d.kp_content_type,
          })),
      };
    }

    return filterCopy;
  });
};
